var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { getCSSSizeValue } from "../../helpers/styles";
import { DEFAULT_MIN_WIDTH } from "./const";
export var Section = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: ", ";\n"], ["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: ",
    ";\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth && getCSSSizeValue(minWidth, DEFAULT_MIN_WIDTH);
});
var templateObject_1;
//# sourceMappingURL=Section.js.map